import React from 'react';
import IconCaret from '../../../icons/IconCaret';
import ReviewsProvider from './hooks/useReviews';
import './Reviews.scss';

const Reviews = (props) => {
	const [openFirstReview, setOpenFirstReview] = React.useState(false);
	const [openSecondReview, setOpenSecondReview] = React.useState(false);
	const [openWriteReview, setOpenWriteReview] = React.useState(false);
	const [isLogged, setIsLogged] = React.useState(false);

	return (
		<ReviewsProvider>
			<div
				data-selection={props.componentId}
				className="container vtex-reviews-and-ratings-3-x-container review mw8 center ph5"
				id="reviews-main-container"
			>
				<h3 className="reviewsHeading vtex-reviews-and-ratings-3-x-reviewsHeading review__title t-heading-3 bb b--muted-5 mb5">
					Avaliações
				</h3>
				<div className="reviewsRating vtex-reviews-and-ratings-3-x-reviewsRating review__rating">
					<div className="starsContainer vtex-reviews-and-ratings-3-x-starsContainer t-heading-4">
						<span className="stars vtex-reviews-and-ratings-3-x-stars c-action-primary">
							<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
								☆
							</span>
							<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
								☆
							</span>
							<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
								☆
							</span>
							<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
								☆
							</span>
							<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
								☆
							</span>
						</span>
					</div>
					<span className="reviewsRatingAverage vtex-reviews-and-ratings-3-x-reviewsRatingAverage review__rating--average dib v-mid">
						Classificação média: 5
					</span>
					<span className="reviewsRatingCount vtex-reviews-and-ratings-3-x-reviewsRatingCount review__rating--count dib v-mid">
						(2 avaliações)
					</span>
				</div>
				<div className="writeReviewContainer vtex-reviews-and-ratings-3-x-writeReviewContainer mv5">
					<div className="vtex-styleguide-9-x-jsFocusVisible">
						<div
							className="flex flex-row items-center pointer"
							role="button"
							onClick={(e) => setOpenWriteReview(!openWriteReview)}
						>
							<div className="c-action-primary mr3 self-center">
								{openWriteReview ? (
									<IconCaret orientation="up" handle={'vtex__icon-caret-up'} />
								) : (
									<IconCaret orientation="down" handle={'vtex__icon-caret-down'} />
								)}
							</div>
							<div className="flex-grow-1">
								<span className="writeReviewButton vtex-reviews-and-ratings-3-x-writeReviewButton c-action-primary hover-c-action-primary">
									Escreva uma avaliação
								</span>
							</div>
						</div>
						<div
							role="region"
							style={{
								height: openWriteReview ? 'auto' : 0,
								overflow: 'hidden',
								transition: 'height 250ms ease-in-out 0s',
							}}
						>
							<div className="formContainer vtex-reviews-and-ratings-3-x-formContainer bg-muted-5 pa5 mt2">
								<div
									className="vtex-card card w-100 b2 br2 bg-base c-on-base pa6"
									style={{ 'box-shadow': 'rgba(61, 62, 64, 0.2) 0px 3px 9px 0px' }}
								>
									<h3>Adicionar avaliação</h3>
									<form>
										<div className="formSection formBottomLine vtex-reviews-and-ratings-3-x-formSection vtex-reviews-and-ratings-3-x-formBottomLine mv3">
											<label className="vtex-input w-100">
												<span className="vtex-input__label db mb3 w-100 c-on-base t-body ">Título</span>
												<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-large ">
													<input
														className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-hideDecorators vtex-styleguide-9-x-noAppearance br2   w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body ph5 "
														required=""
														type="text"
													/>
												</div>
											</label>
										</div>
										<div className="formSection formRating vtex-reviews-and-ratings-3-x-formSection vtex-reviews-and-ratings-3-x-formRating mv3">
											<label className="starpicker vtex-reviews-and-ratings-3-x-starpicker c-action-primary">
												<span className="vtex-input__label db mb3 w-100 c-on-base ">
													Avalie o produto de 1 a 5 estrelas
												</span>
												<span className="t-heading-4 pointer">
													<span
														className="vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled"
														role="button"
													>
														★
													</span>
													<span
														className="vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled"
														role="button"
													>
														★
													</span>
													<span
														className="vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled"
														role="button"
													>
														★
													</span>
													<span
														className="vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled"
														role="button"
													>
														★
													</span>
													<span
														className="vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled"
														role="button"
													>
														★
													</span>
												</span>
											</label>
										</div>
										<div className="formSection formName vtex-reviews-and-ratings-3-x-formSection vtex-reviews-and-ratings-3-x-formName mv3">
											<label className="vtex-input w-100">
												<span className="vtex-input__label db mb3 w-100 c-on-base t-body ">Seu nome</span>
												<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-large ">
													<input
														className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-hideDecorators vtex-styleguide-9-x-noAppearance br2   w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body ph5 "
														type="text"
													/>
												</div>
											</label>
										</div>
										<div className="formSection formReview vtex-reviews-and-ratings-3-x-formSection vtex-reviews-and-ratings-3-x-formReview mv3">
											<label className="vtex-textarea">
												<span className="vtex-textarea__label db mb3 w-100 t-body ">Escreva uma avaliação</span>
												<textarea
													className="vtex-textarea__input w-100 ma0 border-box pv3 ph5 bw1 br2 b--solid outline-0 c-on-base t-small b--muted-4 hover-b--muted-3 bg-base t-body "
													rows="5"
													style={{ resize: 'both', appearance: 'none' }}
												></textarea>
												<div className="flex justify-between">
													<div></div>
												</div>
											</label>
										</div>
										<div className="formSection formSubmit vtex-reviews-and-ratings-3-x-formSection vtex-reviews-and-ratings-3-x-formSubmit mv3">
											<button
												tabindex="0"
												className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-regular t-action bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer "
												type="button"
											>
												<div
													className="vtex-button__label flex items-center justify-center h-100 ph6 "
													style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
												>
													Enviar avaliação
												</div>
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="reviewsOrderBy vtex-reviews-and-ratings-3-x-reviewsOrderBy flex mb7">
					<div className="vtex-styleguide-9-x-dropdown vtex-dropdown">
						<label className="h-100">
							<div className="container vtex-styleguide-9-x-container vtex-dropdown__container br2 relative bw1 bg-base ba h-regular hover-b--muted-3 b--muted-4 t-body">
								<div className="vtex-dropdown__button bg-transparent bn w-100 h-100 pl5 pr3 pointer c-on-base">
									<div className="flex h-100">
										<div className="vtex-dropdown__caption flex-auto tl truncate h-100">
											<div className="h-100 flex items-center">Mais recentes</div>
										</div>
										<div className="vtex-dropdown__arrow flex-none flex items-center pl2 c-action-primary">
											<svg width="18" height="18" viewBox="0 0 24 24">
												<g fill="currentColor">
													<path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path>
												</g>
											</svg>
										</div>
									</div>
								</div>
								<select
									className="o-0 absolute top-0 left-0 h-100 w-100 bottom-0 t-body pointer"
									style={{ '-webkit-appearance': 'menulist-button' }}
								>
									<option disabled="" value="">
										Ordenar por:
									</option>
									<option selected="" value="SearchDate:desc">
										Mais recentes
									</option>
									<option value="SearchDate:asc">Mais antigas</option>
									<option value="Rating:desc">Classificação mais alta</option>
									<option value="Rating:asc">Classificação mais baixa</option>
								</select>
							</div>
						</label>
					</div>
					<div className="vtex-styleguide-9-x-dropdown vtex-dropdown">
						<label className="h-100">
							<div className="vtex-styleguide-9-x-container vtex-dropdown__container br2 relative bw1 bg-base ba h-regular hover-b--muted-3 b--muted-4 t-body">
								<div className="vtex-dropdown__button bg-transparent bn w-100 h-100 pl5 pr3 pointer c-on-base">
									<div className="flex h-100">
										<div className="vtex-dropdown__caption flex-auto tl truncate h-100">
											<div className="h-100 flex items-center">Todos</div>
										</div>
										<div className="vtex-dropdown__arrow flex-none flex items-center pl2 c-action-primary">
											<svg width="18" height="18" viewBox="0 0 24 24">
												<g fill="currentColor">
													<path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path>
												</g>
											</svg>
										</div>
									</div>
								</div>
								<select
									className="o-0 absolute top-0 left-0 h-100 w-100 bottom-0 t-body pointer"
									style={{ '-webkit-appearance': 'menulist-button' }}
								>
									<option disabled="" value="">
										Filtrar por:
									</option>
									<option selected="" value="0">
										Todos
									</option>
									<option value="1">1 estrela</option>
									<option value="2">2 estrelas</option>
									<option value="3">3 estrelas</option>
									<option value="4">4 estrelas</option>
									<option value="5">5 estrelas</option>
								</select>
							</div>
						</label>
					</div>
				</div>
				<div className="reviewCommentsContainer vtex-reviews-and-ratings-3-x-reviewCommentsContainer review__comments">
					<div className="review__comment bw2 bb b--muted-5 mb5 pb4">
						<h5 className="review__comment--user lh-copy mw9 t-heading-5 mv5">Nenhuma avaliação</h5>
					</div>
				</div>
				<div class="reviewCommentsContainer vtex-reviews-and-ratings-3-x-reviewCommentsContainer review__comments">
					<div class="reviewComment vtex-reviews-and-ratings-3-x-reviewComment review__comment bw2 bb b--muted-5 mb5 pb4">
						<div class="vtex-styleguide-9-x-jsFocusVisible">
							<div
								onClick={(e) => setOpenFirstReview(!openFirstReview)}
								class="flex flex-row items-center pointer"
								tabindex="0"
								role="button"
								aria-expanded="false"
							>
								<div class="c-action-primary mr3 self-center">
									{openFirstReview ? (
										<IconCaret orientation="up" handle={'vtex__icon-caret-up'} />
									) : (
										<IconCaret orientation="down" handle={'vtex__icon-caret-down'} />
									)}
								</div>
								<div class="flex-grow-1">
									<div class="reviewCommentRating vtex-reviews-and-ratings-3-x-reviewCommentRating review__comment--rating t-heading-5">
										<span class="stars vtex-reviews-and-ratings-3-x-stars c-action-primary">
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
										</span>
										<span class="reviewCommentUser vtex-reviews-and-ratings-3-x-reviewCommentUser review__comment--user lh-copy mw9 t-heading-5 mt0 mb2">
											Teste
										</span>
									</div>
								</div>
							</div>
							<div
								role="region"
								style={{
									height: openFirstReview ? 'auto' : '0px',
									overflow: 'hidden',
									transition: 'height 250ms ease-in-out 0s',
								}}
							>
								<ul class="pa0 mv2 t-small">
									<li class="dib mr2">
										Enviado <strong>agora</strong>
									</li>
									<li class="dib mr5">
										por <strong>Rodrigo Prates</strong>
									</li>
								</ul>
								<p class="t-body lh-copy mw9">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi dapibus vestibulum nunc a consequat.
									Nam dictum efficitur metus, efficitur fermentum nisl mollis non. Curabitur eget nisl vel eros
									imperdiet posuere sit amet in nulla. Quisque tortor arcu, molestie sit amet ornare a, dictum nec
									metus. Aliquam non tellus quis eros placerat tristique sed at magna. Maecenas diam metus, vestibulum
									eget ante non, feugiat elementum nunc. Cras sed facilisis ipsum, ut condimentum sem. Curabitur ac
									cursus risus. Vivamus mollis erat ligula, at porttitor enim tincidunt vel. Vivamus fringilla tempor
									maximus. Suspendisse sollicitudin, odio nec consectetur aliquet, neque nunc vestibulum mauris, id
									luctus mi dolor sed eros. Quisque viverra dui vel viverra feugiat. Maecenas semper sapien sed pulvinar
									efficitur. Integer tempus faucibus elit et venenatis. Duis ac sodales metus. Maecenas at eros
									consequat, aliquam ipsum id, malesuada nunc. Donec et orci consequat, ultrices metus interdum,
									imperdiet nibh. Duis placerat vulputate mi ut sodales. Sed egestas tristique mauris sed tincidunt. Nam
									nec odio sit amet justo volutpat pulvinar. Quisque tempor ex id libero faucibus tristique. Vestibulum
									eu ligula libero. Etiam at tempus nunc. Etiam tincidunt bibendum risus auctor vulputate. Duis tempor
									tempor accumsan. Vestibulum id velit laoreet, hendrerit massa in, viverra dui. Donec malesuada
									ultricies metus. Nam facilisis diam in ex aliquet laoreet. Vestibulum faucibus magna ac leo molestie
									ornare. Vestibulum dui nisl, volutpat vel venenatis eu, placerat quis libero. Mauris mollis
									sollicitudin feugiat. Nullam et suscipit leo.
								</p>
							</div>
						</div>
					</div>
					<div class="reviewComment vtex-reviews-and-ratings-3-x-reviewComment review__comment bw2 bb b--muted-5 mb5 pb4">
						<div class="vtex-styleguide-9-x-jsFocusVisible">
							<div
								onClick={(e) => setOpenSecondReview(!openSecondReview)}
								class="flex flex-row items-center pointer"
								tabindex="0"
								role="button"
								aria-expanded="false"
							>
								<div class="c-action-primary mr3 self-center">
									{openSecondReview ? (
										<IconCaret orientation="up" handle={'vtex__icon-caret-up'} />
									) : (
										<IconCaret orientation="down" handle={'vtex__icon-caret-down'} />
									)}
								</div>
								<div class="flex-grow-1">
									<div class="vtex-reviews-and-ratings-3-x-reviewCommentRating review__comment--rating t-heading-5">
										<span class="stars star--filled vtex-reviews-and-ratings-3-x-stars c-action-primary">
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
											<span class="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
												★
											</span>
										</span>
										<span class="reviewCommentUser vtex-reviews-and-ratings-3-x-reviewCommentUser review__comment--user lh-copy mw9 t-heading-5 mt0 mb2">
											Muito bom
										</span>
									</div>
								</div>
							</div>
							<div
								role="region"
								style={{
									height: openSecondReview ? 'auto' : '0px',
									overflow: 'hidden',
									transition: 'height 250ms ease-in-out 0s',
								}}
							>
								<ul class="pa0 mv2 t-small">
									<li class="dib mr2">
										Enviado <strong>10 dias atrás</strong>
									</li>
									<li class="dib mr5">
										por <strong>lucas</strong>
									</li>
								</ul>
								<p class="t-body lh-copy mw9">parabéns</p>
							</div>
						</div>
					</div>
					<div class="reviewsPaging vtex-reviews-and-ratings-3-x-reviewsPaging review__paging">
						<div class="flex flex-column">
							<div class="flex flex-row items-center justify-end">
								<div class="flex flex-row pt5 items-center">
									<div class="c-muted-2 t-small">1 - 2 de 2 </div>
									<div class="ml4">
										<button
											tabindex="0"
											class="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-small t-action--small icon-button dib bg-disabled b--muted-5 c-on-disabled "
											type="button"
											style={{ fontSize: '0px;' }}
										>
											<div
												class="vtex-button__label flex items-center justify-center h-100 ph3 "
												style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
											>
												<svg
													class="vtex__icon-caret-left  "
													width="11.428571428571429"
													height="16"
													viewBox="0 0 10 14"
													fill="none"
												>
													<path
														d="M7.72356 8.48154C7.32958 8.89452 6.67042 8.89452 6.27644 8.48154L0 1.90235L1.81481 0L7 5.43529L12.1852 0L14 1.90235L7.72356 8.48154Z"
														transform="translate(9.23999) rotate(90)"
														fill="currentColor"
													></path>
												</svg>
											</div>
										</button>
									</div>
									<div class="ml2">
										<button
											tabindex="0"
											class="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-small t-action--small icon-button dib bg-disabled b--muted-5 c-on-disabled "
											type="button"
											style={{ 'font-size': '0px' }}
										>
											<div
												class="vtex-button__label flex items-center justify-center h-100 ph3 "
												style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
											>
												<svg
													class="vtex__icon-caret-right  "
													width="11.428571428571429"
													height="16"
													viewBox="0 0 10 14"
													fill="none"
												>
													<path
														d="M7.72356 8.48154C7.32958 8.89452 6.67042 8.89452 6.27644 8.48154L0 1.90235L1.81481 0L7 5.43529L12.1852 0L14 1.90235L7.72356 8.48154Z"
														transform="translate(0 14) rotate(-90)"
														fill="currentColor"
													></path>
												</svg>
											</div>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ReviewsProvider>
	);
};

export default Reviews;
